import Vue from "vue";
import VueRouter from "vue-router";
import BranchDetails from "../views/BranchDetails/BranchDetails";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "BranchDetails",
    component: BranchDetails
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },

  {
    path: "/fileupload",
    name: "FileUpload",
    component: () => import("../views/FileUpload/FileUpload")
  },

  {
    path: "/EditDetails",
    name: "EditDetails",
    component: () => import("../views/EditBranchDetails/EditBranchDetails")
  }
];

const router = new VueRouter({
  routes
});

export default router;
